<template>
  <v-container grid-list-xl>
    <v-title>
      <slot></slot>
    </v-title>

    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex sm12 md12 lg12>
          <v-autocomplete
            :items="results"
            label="Search for physical street address, not PO Box"
            :search-input.sync="search"
            v-model="streetAddress"
            item-text="formatted_address"
            item-value="formatted_address"
            @change="completeAddress"
            :filter="customFilter"
            persistent-hint
            browser-autocomplete="off"
          >
            <template slot="nodata" slot-scope="data"></template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row>
      <v-btn @click.native="setAddress(0)" :disabled="inactive" color="primary">Set as New Site</v-btn>
      <v-btn @click.native="setAddress(1)" :disabled="inactive" color="primary">Set as Postal</v-btn>
      <v-btn @click.native="setAddress(2)" :disabled="inactive" color="secondary">Set as Both</v-btn>
    </v-layout>

    <v-layout row>
      <v-flex sm6 md6 lg6>
        <v-text-field
          prepend-icon="add_location"
          label="New Site Address:"
          name="currentSiteAddress"
          data-vv-as="New Site Address"
          :disabled="inactive"
          v-model="details.newSiteAddress"
          :box="isReadOnly"
          :error-messages="errors.collect('currentSiteAddress')"
          v-validate="'required'"
        />
      </v-flex>

      <v-flex sm6 md6 lg6>
        <v-text-field
          prepend-icon="local_post_office"
          label="Postal Address:"
          name="postalAddress"
          data-vv-as="Postal Address"
          :disabled="inactive"
          v-model="details.postalAddress"
          :box="isReadOnly"
          :error-messages="errors.collect('postalAddress')"
          v-validate="'required'"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { createNamespacedHelpers } from "vuex";
import { HTTP } from "@/http-common";
import { mapAddressFields, mapCustomerFields } from "@/store/modules/orders";
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
const {
  mapActions: mapAddressActions,
  mapMutations: mapAddressMutations
} = createNamespacedHelpers(`orders/address`);
const { mapActions: mapCustomerActions } = createNamespacedHelpers(
  `orders/customer`
);

export default {
  name: "UtilityAddressSetter",
  inject: {
    $validator: "$validator"
  },
  props: {
    addressList: Array,
    send: Boolean,
    inactive: Boolean,
    isReadOnly: Boolean,
    details: Object,
    customerID: Number,
    hasCurrentAddress: Boolean,
    newCustomer: Boolean
  },
  data() {
    return {
      isDataLoading: false,
      isSaved: false,

      isSubmittedSuccessfully: false,
      isLoaded: false,
      search: null,
      streetAddress: null,
      suburb: null,
      state: null,
      postCode: null,
      results: [],
      address: null,
      fullAddress: null
    };
  },
  mounted() {},
  methods: {
    ...mapAddressActions(["searchAddress", "createAddress"]),
    clearDropdown: function(e) {
      let vm = this;
      vm.results = [];
    },
    addAddressToList() {
      let vm = this;
      if (vm.fullAddress) {
        vm.addressList.push(vm.fullAddress);
        vm.$emit("close");
      }
    },
    setAddress(setting) {
      let vm = this;
      if (vm.fullAddress) {
        
        switch (setting) {
          case 0:
            vm.details.newSiteAddress = vm.fullAddress.formattedAddress;

            break;
          case 1:
            vm.details.postalAddress = vm.fullAddress.formattedAddress;
            break;
          case 2:
            vm.details.newSiteAddress = vm.fullAddress.formattedAddress;
            vm.details.postalAddress = vm.fullAddress.formattedAddress;
            break;
        }
      }
      vm.$forceUpdate();
      vm.$validator.validateAll();
    },
    completeAddress(event) {
      let vm = this;
      var match = vm.results.filter(x => x.formatted_address === event);
      var data = { match, event };
      vm.createAddress(data).then(res => {
        vm.fullAddress = res;
      });
    },
    customFilter(item, queryText, itemText) {
      return true;
      var words = queryText.split(" ").filter(x => x.length > 0);
      var result = false;
      words.forEach(x => {
        result = result || itemText.toLowerCase().includes(x.toLowerCase());
      });
      return result;
    }
  },
  watch: {
    search(val) {
      if (val !== null) {
        if (val.length > 5)
          this.searchAddress(val).then(res => (this.results = res));
      }
    }
  }
};
</script>
